import { render, staticRenderFns } from "./icon-font-demo.vue?vue&type=template&id=35c88d38&scoped=true"
import script from "./icon-font-demo.vue?vue&type=script&lang=js"
export * from "./icon-font-demo.vue?vue&type=script&lang=js"
import style0 from "./icon-font-demo.vue?vue&type=style&index=0&id=35c88d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c88d38",
  null
  
)

export default component.exports